import axios from 'axios';
import { Http } from '../library';
import { httpMethods } from '../enums';
import * as Endpoints from '../constants/endpoints.constant';
import api from '../api/client';

/* eslint-disable */
class DashboardService {
  /**
   * Get passbook summary
   * @param customerId
   */
  async getPassbookSummary(customerId: number, userId: string) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(
        `${Endpoints.PASSBOOK_SUMMARY}?customerId=${customerId}&currency=INR&uom=g&ruleType=BUYBACK&user_id=${userId}`
      )
      .setToken(api.getToken())
      .request();
  }

  /**
   * Get price rules
   * @param metalCode
   * @param customerId
   * @param ruleType
   */
  async getPriceRules(metalCode: any, customerId: number, ruleType: string) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(
        `${Endpoints.PRICE_RULES}?metalCode=${metalCode}&currency=INR&uom=g&customerId=${customerId}&ruleType=${ruleType}`
      )
      .request();
  }

  /**
   * Get all metals
   */
  async getAllMetals() {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.QUOTE_MASTER}?active=ENABLED&orderBy=metal_code`)
      .setToken(api.getToken())
      .request();
  }

  async getInvestmentValue(data) {
    return await Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.CUSTOMER_HOLDINGS}`)
      .setToken(api.getToken())
      .request();
  }
}

export default new DashboardService();
